export const breadcrumbMap = {
  "/": { key: "menu.dashboard", clickable: true },
  "/anagrafica": { key: "menu.anagrafica", clickable: false },
  "/anagrafica/clienti": { key: "menu.clienti", clickable: true },
  "/anagrafica/concessionari": { key: "menu.concessionari", clickable: true },
  "/anagrafica/capi_area": { key: "menu.capi_area", clickable: true },
  "/commerciale/listini": { key: "menu.listini", clickable: true },
  "/magazzino/articoli": { key: "menu.articoli", clickable: true },
  "/commerciale/tipi_locazione": {
    key: "menu.tipi_locazione",
    clickable: true,
  },
  "/anagrafica/gestione_file": { key: "menu.gestione_file", clickable: true },
  "/prestazioni": { key: "menu.prestazioni", clickable: false },
  "/prestazioni/offerte": { key: "menu.offerte", clickable: true },
  "/prestazioni/ordini": { key: "menu.ordini", clickable: true },
  "/pulizia": { key: "menu.pulizia", clickable: false },
  "/pulizia/calendario": { key: "menu.calendario_pulizie", clickable: true },
  "/pulizia/anagrafica-pulitori": {
    key: "menu.anagrafica_pulitori",
    clickable: true,
  },
  "/pulizia/gestione": { key: "menu.gestione_pulizie", clickable: true },
  "/amministrazione": { key: "menu.amministrazione", clickable: false },
  "/amministrazione/fatture": { key: "menu.fatture", clickable: true },
  "/amministrazione/fatture-veicoli": {
    key: "menu.vehicle_invoices",
    clickable: true,
  },
  "/amministrazione/insurance": { key: "menu.insurance", clickable: true },
  "/magazzino": { key: "menu.magazzino", clickable: false },
  "/magazzino/gestione": { key: "menu.gestione_magazzino", clickable: true },
  "/magazzino/automezzi": { key: "menu.automezzi", clickable: true },
  "/notifiche": { key: "menu.notifiche", clickable: true },
  "/settings": { key: "common.settings", clickable: true },

  "/registry": { key: "menu.anagrafica", clickable: false },
  "/registry/customers": { key: "menu.clienti", clickable: true },
  "/registry/dealers": { key: "menu.concessionari", clickable: true },
  "/registry/area-managers": { key: "menu.capi_area", clickable: true },
  "/registry/pricelists": { key: "menu.listini", clickable: true },
  "/warehouse/items": { key: "menu.articoli", clickable: true },
  "/registry/rental-types": { key: "menu.tipi_locazione", clickable: true },
  "/registry/file-management": { key: "menu.gestione_file", clickable: true },
  "/services": { key: "menu.prestazioni", clickable: false },
  "/services/offers": { key: "menu.offerte", clickable: true },
  "/services/orders": { key: "menu.ordini", clickable: true },
  "/cleaning": { key: "menu.pulizia", clickable: false },
  "/cleaning/calendar": { key: "menu.calendario_pulizie", clickable: true },
  "/cleaning/cleaners-registry": {
    key: "menu.anagrafica_pulitori",
    clickable: true,
  },
  "/cleaning/management": { key: "menu.gestione_pulizie", clickable: true },
  "/administration": { key: "menu.amministrazione", clickable: false },
  "/administration/invoices": { key: "menu.fatture", clickable: true },
  "/administration/vehicle-invoices": {
    key: "menu.vehicle_invoices",
    clickable: true,
  },
  "/administration/insurance": { key: "menu.insurance", clickable: true },
  "/warehouse": { key: "menu.magazzino", clickable: false },
  "/warehouse/management": { key: "menu.gestione_magazzino", clickable: true },
  "/warehouse/vehicles": { key: "menu.automezzi", clickable: true },
  "/notifications": { key: "menu.notifiche", clickable: true },

  "/registre": { key: "menu.anagrafica", clickable: false },
  "/registre/clients": { key: "menu.clienti", clickable: true },
  "/registre/concessionnaires": { key: "menu.concessionari", clickable: true },
  "/registre/chefs-de-zone": { key: "menu.capi_area", clickable: true },
  "/registre/tarifs": { key: "menu.listini", clickable: true },
  "/registre/articles": { key: "menu.articoli", clickable: true },
  "/registre/types-location": { key: "menu.tipi_locazione", clickable: true },
  "/registre/gestion-fichiers": { key: "menu.gestione_file", clickable: true },
  "/prestations": { key: "menu.prestazioni", clickable: false },
  "/prestations/offres": { key: "menu.offerte", clickable: true },
  "/prestations/commandes": { key: "menu.ordini", clickable: true },
  "/nettoyage": { key: "menu.pulizia", clickable: false },
  "/nettoyage/calendrier": { key: "menu.calendario_pulizie", clickable: true },
  "/nettoyage/registre-nettoyeurs": {
    key: "menu.anagrafica_pulitori",
    clickable: true,
  },
  "/nettoyage/gestion": { key: "menu.gestione_pulizie", clickable: true },
  "/administration/factures": { key: "menu.fatture", clickable: true },
  "/administration/factures-vehicules": {
    key: "menu.vehicle_invoices",
    clickable: true,
  },
  "/administration/assurance": { key: "menu.insurance", clickable: true },
  "/entrepot": { key: "menu.magazzino", clickable: false },
  "/entrepot/gestion": { key: "menu.gestione_magazzino", clickable: true },
  "/entrepot/vehicules": { key: "menu.automezzi", clickable: true },
  "/parametres": { key: "common.settings", clickable: true },
};
